import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import settingsReader from '../../store/readHelpers/SettingsReader';

class QuestionNumber extends React.PureComponent {
    static propTypes = {
        isDocument: PropTypes.bool,
        isForm: PropTypes.bool,
        isContentBlock: PropTypes.bool,
        mode: PropTypes.string,
        noTitle: PropTypes.bool,
        question: PropTypes.object,
        sectionHasStimulus: PropTypes.bool,
        sectionQuestionsCount: PropTypes.number,
    };

    focus() {
        if (this.numberElement) {
            this.numberElement.focus();
        }
    }

    getQuestionNumber() {
        const { question, sectionHasStimulus, sectionQuestionsCount } = this.props;

        if (sectionHasStimulus && sectionQuestionsCount === 1 && !settingsReader.useTestSequential()) {
            return null;
        } else if (sectionHasStimulus && settingsReader.useSectionAlphaNumeric()) {
            if (question.subQuestionNumber) {
                return `(${question.questionNumberingInSection}) (${question.subQuestionNumber})`;
            }
            return `(${question.questionNumberingInSection})`;
        } else if (settingsReader.useSectionNumeric()) {
            if (sectionHasStimulus) {
                return question.questionNumberingInSection;
            } else if (sectionQuestionsCount === 1) {
                return question.sectionNumber;
            }
        }

        if (scorableItemNumberingService.useNumberPerInteraction()) {
            return scorableItemNumberingService.getQuestionNumber(question.contentRevisionId);
        }

        return question.number;
    }

    render() {
        const { isDocument, isForm, isContentBlock, mode, noTitle, question } = this.props;
        const printStyle = sessionReader.getPrintParam('printStyle');
        let classNames = ['question-margin', 'left'];
        if (scorableItemNumberingService.useNumberPerInteraction()) {
            classNames = ['per-scorable-item-number'];
        }
        if (printStyle) {
            classNames.push(`print-style-${printStyle}`);
        }
        if (noTitle) {
            classNames.push('no-title');
        }
        if (sessionReader.isViewMediaPrintOrPdf()) {
            classNames.push('print');
        }
        if (sessionReader.getPrintParam('noMargins')) {
            classNames.push('noMargins');
        }

        let questionTypeIcon;
        if (isDocument || !question.questionNumberingInSection) {
            questionTypeIcon = 'fa-info';
        } else if (isForm) {
            questionTypeIcon = 'fa-check-square-o';
        } else if (isContentBlock) {
            questionTypeIcon = 'fa-file-text-o';
        }

        return (
            <div className={classNames.join(' ')}>
                <div
                    className={mode === 'question' ? 'hidden no-outline' : 'no-outline'}
                    ref={(div) => { this.numberElement = div; }}
                    tabIndex="-1"
                >
                    {
                        questionTypeIcon ?
                            <i className={`fa ${questionTypeIcon}`} aria-hidden="true" />
                            :
                            <div>
                                <span className="sr-only">{t('generic.questionNumberPrefix')}</span>
                                <span className="question-number">{this.getQuestionNumber()}</span>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default QuestionNumber;
